module.exports = __webpack_public_path__ + "static/media/features_toolkit.53e8f73d.svg";